import type React from "react";
import {useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {faEdit} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

const EditButton: React.FC = () => {
  const {id} = useParams<{id: string}>();
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (id) navigate("/create/" + id);
  }, [id, navigate]);

  return (
    <CustomButton
      onClick={handleClick}
      aria-label="Edit level"
      className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
    >
      <FontAwesomeIcon
        icon={faEdit}
        size="xl"
        className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-blue-600 via-blue-500 to-black"
      />
    </CustomButton>
  );
};

export default EditButton;
